import { render, staticRenderFns } from "./RatesTemplate.vue?vue&type=template&id=21f2fd52&"
import script from "./RatesTemplate.vue?vue&type=script&lang=js&"
export * from "./RatesTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports